import Vue from "vue";
import Router from "vue-router";
import landingpage from "@/components/landingpage";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "landingpage",
      component: landingpage,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js